import { Box, IconButton, Typography, Tooltip } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";

const styles = {
  container: {
    //boxShadow: "0px 1px 8px 0px #00000026",
    border: "1px solid #00000026",
    boxSizing: "border-box !important",
    padding: "30px 24px",
    borderRadius: "8px",
    width: "100%",
    height: "100%",
    position: "relative",
  },
  title: {
    fontWeight: "600",
    fontSize: "22px",
    lineHeight: "30px",
    marginBottom: "2px",
    color: "#063F5E",
    fontFamily: "Ninuto, sans-serif !important",
  },
  text: {
    fontFamily: "Ninuto, sans-serif !important",
    fontSize: "13px",
    fontWeight: 400,
    lineHeight: "22px",
    color: " #737373 !important",
  },
};

export default function CardBaseMonitoring({
  children,
  title,
  subTitle = "",
  titleVal = "",
  status = "Normal",
  statusColor = "#3AB238",
  funcRefresh = () => {},
  funcDetail = null,
  lastUpdate,
}) {
  return (
    <Box sx={styles.container}>
      {!!funcDetail && (
        <Tooltip
          componentsProps={{
            tooltip: {
              sx: {
                bgcolor: "#D3E3EB",
              },
            },
          }}
          title={
            <Box
              sx={{
                fontSize: "16px",
                color: "#1E729F",
                background: "transparent !important",
              }}
            >
              Ampliar gráfico
            </Box>
          }
          placement="top"
        >
          <IconButton
            sx={{
              position: "absolute",
              right: "0px",
              top: "0px",
            }}
            onClick={funcDetail}
          >
            <OpenInFullIcon style={{ width: "20px", height: "20px" }} />
          </IconButton>
        </Tooltip>
      )}

      <Box
        display="flex"
        height="100%"
        flexDirection="column"
        justifyContent="space-between"
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          gap="20px"
        >
          <Box>
            <Box position="relative" width="fit-content">
              <Typography component="h3" sx={styles.title}>
                {title}
              </Typography>
              <IconButton
                sx={{
                  position: "absolute",
                  right: "-33px",
                  top: "-10px",
                }}
                onClick={funcRefresh}
              >
                <RefreshIcon style={{ width: "20px", height: "20px" }} />
              </IconButton>
            </Box>
            {!!subTitle && (
              <Typography sx={{ color: "#737373", marginTop: "-6px" }}>
                {subTitle}
              </Typography>
            )}

            <Box display="flex" alignItems="center" justify="center" gap="10px">
              <Box
                width="10px"
                height="10px"
                borderRadius="5px"
                bgcolor={`${statusColor} !important`}
              ></Box>
              <Typography>{status}</Typography>
            </Box>
          </Box>
          {titleVal !== "" && (
            <Typography sx={{ ...styles.title, fontSize: "40px" }}>
              {titleVal}
            </Typography>
          )}
        </Box>

        <Box sx={{ margin: "20px 0px" }}>{children}</Box>

        <Box display="flex" alignItems="center" gap="10px">
          <AccessTimeIcon
            sx={{
              width: "16px",
              height: "16px",
              color: "#737373 !important",
            }}
          />
          <Typography sx={styles.text}>
            Última atualização às {lastUpdate}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
